import { ExpectedDataProps } from '../data';
import styled from 'styled-components';
import ScheduledCard from './ScheduledCard';

interface Props {
  data: ExpectedDataProps[];
  loading: boolean;
}
const List = ({ data, loading }: Props) => {
  return (
    <Container>
      {!loading && data.length > 0 && (
        <ListBox>
          {data.map((item, idx) => (
            <div key={idx}>
              <ScheduledCard item={item} />
            </div>
          ))}
        </ListBox>
      )}
    </Container>
  );
};
export default List;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const ListBox = styled.div`
  width: 100%;
  display: flex;
  padding: 24px 16px;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
`;
